module.exports = __webpack_public_path__ + "static/media/De Heilige Maagd.ab6ba3b8.jpg";